import { Modal } from '@w7/ui'
import { ConsoleMfaControl } from '@/features/security/ConsoleMfaControl'
import { PlayerConsoleMfaControl } from '@/features/security/PlayerConsoleMfaControl'
import { isConsoleMfaAgentLevel } from '@/features/security/consoleMfaCopy'
import { ROLE_LABEL, levelToRole, type HierarchyNode } from './hierarchy'

/**
 * Downline-list 2FA shield → status + on/off controls (agents + portal players).
 */
export function DownlineMfaModal({
  row,
  onClose,
}: {
  row: HierarchyNode
  onClose: () => void
}) {
  const tier = ROLE_LABEL[levelToRole(row.level)]
  const name = row.username || row.name
  const agent = isConsoleMfaAgentLevel(row.level)
  const player = row.level === 6

  return (
    <Modal
      open
      onClose={onClose}
      title={`2FA — ${name}`}
      subtitle={
        agent
          ? `${tier} · console (Keycloak) sign-in factors`
          : player
            ? `${tier} · player portal factors`
            : `${tier}`
      }
    >
      {agent ? (
        <ConsoleMfaControl
          agentId={row.id}
          username={row.username || row.name}
          level={row.level}
        />
      ) : player ? (
        <PlayerConsoleMfaControl
          playerId={row.id}
          username={row.username || row.name}
        />
      ) : (
        <p className="cm-hint" role="status">
          Console 2FA applies to Triple Master → Master and portal Members only.
        </p>
      )}
    </Modal>
  )
}
